import TextField from "../../../../components/fields/textField/TextField.vue";
import TextAreaField from "../../../../components/fields/textAreaField/TextAreaField.vue"
import ConfirmPasswordDialog from "../../../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import PerfilService from "../../../../services/PerfilService";
import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import { AssinaturaMixin } from "@/mixins/assinaturaMixin";
import { SnackbarMixin } from "@/mixins/snackbarMixin";
import { SnackBarModule } from "@/modules/SnackBarModule";
import LoadingBlue from "../../../../components/fields/loading-blue/LoadingBlue";
export default {
    name: "DialogFormExcluir",
    components: {
        TextField,
        ConfirmPasswordDialog,
        PerfilService,
        FormDialog,
        SnackBarModule,
        TextAreaField,
        LoadingBlue
    },
    mixins: [AssinaturaMixin, SnackbarMixin],
    props: {
        perfilid: {
            required: true,
        },
        activeDialog: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        data: [],
        errors: [],
        form: {},
        formTitle: 'ATENÇÃO!',
        loadingButton: false,
        disabled: {
            nome: false,
            perfil: false,
            permissoes: false,
        },
        loading: {
            modal: false,
            table: false,
        },
        formValid: true,
        showFormDialog: false,
        send: {
            function: () => { },
            params: null,
        },
    }),
    watch: {
        activeDialog() {
            this.loadingButton = false;

            if (this.perfilid) {
                this.showFormDialog = !this.showFormDialog;
            }
        },
    },
    goTo(path) {
        this.$router.push(path);
    },
    methods: {
        async save() {
            this.loadingButton = true;
            const data = await PerfilService.excluirPerfil(this.perfilid);
            if (data.error === true) {
                SnackBarModule(data.message, 'error');
            } else {
                SnackBarModule('Perfil excluído com sucesso!', 'success');
                this.$emit("perfilExcluido");
            }
            this.loadingButton = false;
        },
        closed() {
            this.$emit("closed");
        },
    }
}